/**
 * Where an operator enters a practice's dashboard. Always the slug-addressed console, the demo
 * practice included: the bare `/admin` designates whichever slug the browser last remembered,
 * which another tab may have changed (docs/auth-and-admin/super-admin-d3-operator-contract.md 5.1).
 *
 * A practice row without a slug (legacy data: signup always writes one) has no console address,
 * so the answer is null and the caller offers no entry for that practice. It is called while
 * rendering lists, so it never throws: one malformed row must not take the whole screen down.
 */
export const practiceConsoleHref = (slug) => (
  typeof slug === "string" && slug !== "" ? `/t/${slug}/admin` : null
);
